// 24×24 viewBox. 3 bricks with ~1.2px mortar gaps.
// Left column: stem-top (wide, 0.82 opacity) + stem-base (narrow). Bottom-right: bowl (wide).
// Reads as a lowercase 'b'. stem-top opacity nods to the glass→terracotta mark story.
function BrickMark({ width, height, color = '#D2542B', style = {} }) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" style={style}>
      <rect className="br1" x="3" y="4"    width="11" height="6.4"  rx="0.8" fill={color} opacity="0.82" />
      <rect className="br2" x="3" y="11.6" width="6"  height="8.4"  rx="0.8" fill={color} />
      <rect className="br3" x="10.2" y="11.6" width="10.8" height="8.4" rx="0.8" fill={color} />
    </svg>
  );
}

export default function BricksWordmark({ size = 18, color, monoColor = false, showWordmark = true, className = '' }) {
  const textColor = color || '#14110E';
  const markColor = monoColor ? textColor : '#D2542B';
  const markH = Math.round(size * 1.28);

  return (
    <div className={`inline-flex items-center ${className}`} style={{ gap: size * 0.5 }}>
      <BrickMark width={markH} height={markH} color={markColor} />
      {showWordmark && (
        <span style={{
          fontFamily: '"General Sans", ui-sans-serif, system-ui, sans-serif',
          fontSize: size,
          fontWeight: 500,
          letterSpacing: -(size * 0.035),
          color: textColor,
          lineHeight: 1,
        }}>
          bricks
        </span>
      )}
    </div>
  );
}
